// ═══ 말소 홈 `/main/m/home` — 말소 셸 첫 화면 (홈·말소 탭 분리 Jin 10/27 · 앱 malso_home_screen.dart) ═══
// 신청 카드(+ 데스크톱 등록증 드롭존) → 노란 띠(미제출 보강서류) → 3칸(진행 중 · 확인 필요 · 이번 달 완료) →
// 정산 카드(이번 달 청구) → 진행 중인 말소 5건 + 더 보기. 구성은 검차 홈(SimpleHome.js)과 같다.
// 3칸·띠·더 보기는 말소 탭(/main/m/malso?filter=…[&ym=…])으로 — 숫자는 그 칩 건수와 같다(이번 달 완료 = 완료 + 이번 달).
// 데이터: listRequests + myDocRequests('요청') → certFlags · myCancelLedger({month}). 소켓 cancel:step·cancel-doc:* → 목록 재조회.
// props: { user, showToast }
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { T, R, S } from '../../theme';
import { useT, useLocale } from '../../../i18n/I18nProvider';
import { getSocket } from '../../../utils/socket';
import { listRequests, myDocRequests, certFlags, myCancelLedger } from '../api';
import { putFiles } from '../dropHandoff';
import { buildHome, certIdsOf, visibleRows, needsAction, certArrived } from '../homeLogic';
import { isHeic } from '../requestLogic';
import { currentMonth, monthLabel } from '../../simple/fmt';
import { describeSimpleError } from '../../simple/errors';
import { useIsMobile } from '../../../utils/useMobile';
import ErrorText from '../../simple/parts/ErrorText';
import KpiTile from '../../simple/parts/KpiTile';
import SimpleCard from '../../simple/parts/SimpleCard';
import MoneyKRW from '../../simple/parts/MoneyKRW';
import LtrText from '../../simple/parts/LtrText';
import MalsoRow from '../parts/MalsoRow';
import AppNudge from '../../simple/parts/AppNudge';
import JoinWaitCard from '../parts/JoinWaitCard';
import { refreshMalsoJoin } from '../joinRefresh';

var LIST = '/main/m/malso';
var SOCKET_EVENTS = ['cancel:step', 'cancel-doc:requested', 'cancel-doc:message', 'cancel-doc:cancelled'];

var page = { display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 720, width: '100%', margin: '0 auto' };
var top = { display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'stretch' };
var cta = { flex: '1 1 300px', minWidth: 0, display: 'flex', alignItems: 'center', gap: 14, boxSizing: 'border-box',
  background: 'linear-gradient(135deg,' + T.navy + ',' + T.accent + ')', border: 0, borderRadius: R.card, padding: '16px 18px',
  color: T.card, cursor: 'pointer', textAlign: 'start', fontFamily: 'inherit' };
var ctaOff = Object.assign({}, cta, { background: T.line, cursor: 'default' });   // 대행사 연결 전 — 시안 YkShareWaiting 회색 카드
var ctaTitle = { fontSize: 14.5, fontWeight: 800, letterSpacing: '-.2px' };
var ctaDesc = { fontSize: 12, opacity: .82, marginTop: 3 };
var band = { display: 'flex', alignItems: 'center', gap: 8, width: '100%', boxSizing: 'border-box', border: 0,
  background: T.warnTint, color: T.warn, borderRadius: R.lg, padding: '11px 14px', fontSize: 13, fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit', textAlign: 'start' };
var kpiRow = { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 10 };
var cardLinkBtn = { display: 'block', width: '100%', textAlign: 'start', border: 0, background: 'none', padding: 0, fontFamily: 'inherit', cursor: 'pointer' };
var settleBody = { display: 'flex', alignItems: 'flex-end', gap: 16, padding: '13px 15px' };
var settleCol2 = { marginInlineStart: 'auto', textAlign: 'end' };
var settleLabel = { fontSize: 10.5, fontWeight: 700, color: T.faint };
var settleValue = { fontSize: 20, fontWeight: 800, letterSpacing: '-.4px', marginTop: 2, display: 'block' };
var moreRow = { padding: '9px 14px', textAlign: 'center' };
var moreLink = { fontSize: 12, fontWeight: 700, color: T.accentPress, background: 'none', border: 0, cursor: 'pointer', fontFamily: 'inherit', padding: 0 };
var zone = { flex: '1 1 300px', minWidth: 0, boxSizing: 'border-box', border: '1.5px dashed ' + T.accentBd, borderRadius: R.lg,
  background: T.accentTint, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12, color: T.accentPress, fontWeight: 600 };
var zoneOn = Object.assign({}, zone, { border: '1.5px dashed ' + T.accent });
var pick = { flex: 'none', height: 34, padding: '0 14px', borderRadius: R.md, border: '1px solid ' + T.accentBd, background: T.card,
  color: T.accentPress, fontSize: 12.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' };

// 등록증 드롭존 — FinalWeb2 `.drop`. 끌어다 놓기 또는 [파일 선택](여러 장) → onFiles(File[]).
// accept 는 차량 등록 드롭존과 같다(Dropzone.js:30). 이 화면에서만 쓰여 화면 로컬로 둔다.
function DropZone(props) {
  var t = useT();
  var inputRef = useRef(null);
  var st = useState(false); var over = st[0], setOver = st[1];
  var take = function (list) {
    var files = Array.prototype.slice.call(list || []);
    if (files.length) props.onFiles(files);
  };
  return (<div data-testid="malso-drop" style={over ? zoneOn : zone}
    onDragOver={function (e) { e.preventDefault(); setOver(true); }}
    onDragLeave={function () { setOver(false); }}
    onDrop={function (e) { e.preventDefault(); setOver(false); take(e.dataTransfer && e.dataTransfer.files); }}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" aria-hidden="true" focusable="false" style={{ flex: 'none' }}><path d="M12 15V4M7 9l5-5 5 5M5 14v6h14v-6" /></svg>
    <div style={{ flex: 1, minWidth: 0 }}>{t('malsoModeWebDropTitle')}</div>
    <button type="button" style={pick} onClick={function () { if (inputRef.current) inputRef.current.click(); }}>
      {t('malsoModeWebDropPick')}
    </button>
    <input ref={inputRef} type="file" multiple accept="image/*,application/pdf,.pdf" style={{ display: 'none' }}
      data-testid="malso-drop-input" onChange={function (e) { take(e.target.files); e.target.value = ''; }} />
  </div>);
}

/// 말소 탭 주소 — 칩(+기간). 기본값은 생략.
function listUrl(filter, ym) {
  var q = new URLSearchParams();
  if (filter) q.set('filter', filter);
  if (ym) q.set('ym', ym);
  var s = q.toString();
  return LIST + (s ? '?' + s : '');
}

function MalsoHome(props) {
  var t = useT();
  var loc = useLocale();
  var navigate = useNavigate();
  var isMobile = useIsMobile();
  var month = currentMonth();
  // 대표 링크 가입 업체 — 대행사 거래처 연결 전(waiting·declined)엔 대기 안내 + 신청 카드·드롭존 꺼짐(서버도 JOIN_PENDING 으로 막는다)
  var join = (props.user && props.user.malsoJoin) || null;
  var stH = useState(null); var home = stH[0], setHome = stH[1];
  var stE = useState(null); var err = stE[0], setErr = stE[1];
  var stL = useState({ data: null, error: null }); var ledger = stL[0], setLedger = stL[1];

  var load = useCallback(function () {
    return Promise.all([listRequests(), myDocRequests('요청')]).then(function (res) {
      var rows = Array.isArray(res[0]) ? res[0] : [];
      return certFlags(certIdsOf(rows)).then(function (body) {
        setHome(buildHome(rows, res[1], body && body.flags, currentMonth()));
        setErr(null);
      });
    }).catch(function (e) { setErr(e); });
  // setter 2종은 useState 가 보장하는 안정 참조 — 배열 구조분해라 린터가 못 알아본다.
  }, [setHome, setErr]);

  useEffect(function () { load(); }, [load]);

  // 대기 안내 중이면 진입 때 한 번 다시 읽는다 — 그사이 대행사가 연결했으면 세션 갱신 → 셸이 user 를 바꿔 안내가 사라진다.
  useEffect(function () { refreshMalsoJoin(props.user); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    var alive = true;
    myCancelLedger({ month: month }).then(function (body) {
      if (alive) setLedger({ data: body || {}, error: null });
    }).catch(function (e) { if (alive) setLedger({ data: null, error: e }); });
    return function () { alive = false; };
  }, [month, setLedger]);

  useEffect(function () {
    var sock = getSocket(); if (!sock) return undefined;
    var on = function () { load(); };
    SOCKET_EVENTS.forEach(function (ev) { sock.on(ev, on); });
    return function () { try { SOCKET_EVENTS.forEach(function (ev) { sock.off(ev, on); }); } catch (e) { /* 이미 끊김 */ } };
  }, [load]);

  var goRequest = function () { navigate('/main/m/request'); };
  // HEIC 는 빼고 넘긴다(남는 파일이 없으면 이동하지 않음). 파일은 router state 가 아니라 dropHandoff 로.
  var onFiles = function (files) {
    var ok = files.filter(function (f) { return !isHeic(f); });
    if (ok.length < files.length) props.showToast(t('malsoModeWebHeicUnsupported'), 'err');
    if (!ok.length) return;
    putFiles(ok);
    goRequest();
  };

  var active = home ? visibleRows(home, 'active', '') : [];
  var shown = active.slice(0, 5);
  var moreCount = active.length - shown.length;
  var needs = home ? home.counts.needsAction : 0;
  var charges = ledger.data && Array.isArray(ledger.data.rows)
    ? ledger.data.rows.filter(function (r) { return r.kind === 'charge'; }).length : 0;

  return (<div className="ss-malso-home" style={page}>
    <AppNudge />
    {join ? <JoinWaitCard agencyName={join.agencyName} /> : null}
    <div style={top}>
      <button type="button" data-testid="malso-cta" style={join ? ctaOff : cta} disabled={!!join} onClick={goRequest}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={ctaTitle}>{t('malsoModeHomeCtaTitle')}</div>
          <div style={ctaDesc}>{join ? t('malsoModeJoinWaitCta', { agency: join.agencyName || '' }) : t('malsoModeHomeCtaDesc')}</div>
        </div>
        {join ? null : <span className="ss-flipx" aria-hidden="true" style={{ display: 'inline-block', fontSize: 18 }}>›</span>}
      </button>
      {isMobile || join ? null : <DropZone onFiles={onFiles} />}   {/* 터치 기기는 끌어다 놓기 불가 — 신청 카드가 같은 역할 */}
    </div>

    {home && home.docCount > 0 ? (<button type="button" data-testid="malso-doc-band" style={band}
      onClick={function () { navigate(listUrl('needsAction')); }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
        aria-hidden="true" focusable="false" style={{ flex: 'none' }}><path d="M12 3 2 20h20L12 3zM12 10v4M12 17h.01" /></svg>
      <span style={{ flex: 1, minWidth: 0 }}>{t('malsoModeDocBand', { count: home.docCount })}</span>
      {/* RTL 에서 뒤집힘 — .ss-flipx(simple.css:90), transform 은 inline 에 안 먹어 inline-block (HomeDesktop.js:123 선례) */}
      <span className="ss-flipx" aria-hidden="true" style={{ display: 'inline-block' }}>›</span>
    </button>) : null}

    {err ? <ErrorText>{describeSimpleError(t, err)}</ErrorText> : null}

    {/* 불러오기 전·실패 땐 3칸을 그리지 않는다(0 으로 꾸미지 않음 — KpiTile 은 값을 숫자로 그린다) */}
    {home ? (<div style={kpiRow}>
      <KpiTile label={t('malsoModeStripActive')} count={home.counts.active} tone="accent"
        onClick={function () { navigate(listUrl('active')); }} />
      <KpiTile label={t('malsoModeStripNeedsAction')} count={needs} tone={needs > 0 ? 'warn' : 'ink'}
        onClick={function () { navigate(listUrl('needsAction')); }} />
      <KpiTile label={t('malsoModeStripDoneThisMonth')} count={home.doneMonth} tone="ink"
        onClick={function () { navigate(listUrl('done', month)); }} />
    </div>) : null}

    <button type="button" data-testid="malso-settle" style={cardLinkBtn} onClick={function () { navigate('/main/m/ledger'); }}>
      <SimpleCard title={t('malsoModeTabLedger')}>
        {ledger.error ? null : (<div style={settleBody}>
          <div>
            <div style={settleLabel}>{monthLabel(loc.locale, month)}</div>
            <span style={settleValue}>{ledger.data ? t('cancelHistoryCountUnit', { count: charges }) : '–'}</span>
          </div>
          <div style={settleCol2}>
            <div style={settleLabel}>{t('ledgerKindCharge')}</div>
            {ledger.data ? <MoneyKRW won={Number(ledger.data.charged) || 0} style={Object.assign({}, settleValue, { color: T.money })} />
              : <LtrText style={settleValue}>–</LtrText>}
          </div>
        </div>)}
      </SimpleCard>
    </button>

    <SimpleCard title={t('malsoModeHeroKicker')}>
      {!home ? null : shown.length === 0 ? <div style={S.emptyText}>{t('malsoModeHomeActiveEmpty')}</div> : (<div>
        {shown.map(function (r) {
          return (<MalsoRow key={r.id} row={r} needsAction={needsAction(home, r)} certArrived={certArrived(home, r)}
            onClick={function () { navigate(LIST + '/' + r.id); }} />);
        })}
        {moreCount > 0 ? (<div style={moreRow}>
          <button type="button" style={moreLink} onClick={function () { navigate(listUrl('active')); }}>
            {t('simpleB1ActiveMore', { count: moreCount })}
          </button>
        </div>) : null}
      </div>)}
    </SimpleCard>
  </div>);
}

export default MalsoHome;
